// extracted by mini-css-extract-plugin
module.exports = {"cardLink":"styles-module--cardLink--s_jqd","sexyShadow":"styles-module--sexyShadow--3-QnR","card":"styles-module--card--2ZBhC"};